import Carousel from 'base-components/Carousel'
import Modal from 'base-components/Modal'
import { FC } from 'react'

interface Props {
  open: boolean
  defaultImage?: string
  images: string[]
  onClose: () => void
}

const ImageGalleryModal: FC<Props> = ({ open, onClose, defaultImage, images }) => {
  return (
    <Modal open={open} onClose={onClose} className='w-1/2'>
      <Carousel images={images} id={'modalImageGallery'} defaultImage={defaultImage} />
    </Modal>
  )
}

export default ImageGalleryModal
